<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Seite kopieren"
                :ok-disabled="!validate"
                @ok="submit" :loading="loading"
                @cancel="close" @click:outside="close">
            <Input v-model="name" label="Bezeichnung"
                   :error-messages="name_errors" :required="true"
                   @input="$v.name.$touch()"
                   @blur="$v.name.$touch()"
            ></Input>
            <Dropdown v-model="selected_publisher" :items="publisher"
                      label="Publisher"
                      :error-messages="publisher_errors"
                      item-text="Name" item-value="Name"
                      @input="$v.selected_publisher.$touch()"
                      @blur="$v.selected_publisher.$touch()"
            ></Dropdown>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Seite erfolgreich kopiert.</Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Utils from "../../../scripts/Utils";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Input from "../../../components/Inputs/Input";
import Dropdown from "../../../components/Inputs/Dropdown";
import Snackbar from "../../../components/Snackbar";

export default {
    name: "CopySiteDialog",
    components: {Snackbar, Dropdown, Input, Dialog},
    props: ['value'],
    mixins: [validationMixin],
    validations: {
        name: {required},
        selected_publisher: {required}
    },
    data: () => {
        return {
            name: null,
            selected_publisher: null,
            successSnackbar: false,
            loading: false,
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        selectedSite() {
            return this.$store.state.settings.selectedItem;
        },
        publisher() {
            return this.vuexState.publisher || [];
        },
        name_errors() {
            return Utils.handleError(this, 'name', 'Bezeichnnung ist erforderlich.');
        },
        publisher_errors() {
            return Utils.handleError(this, 'selected_publisher', 'Publisher ist erforderlich.');
        },
        validate() {
            return this.name_errors.length === 0 &&
                this.publisher_errors.length === 0
        }
    },
    methods: {
        init() {
            if (this.selectedSite) {
                this.name = this.selectedSite.Name + Utils.getDateString();
                this.selected_publisher = this.publisher.find(x => x.PublisherId === this.selectedSite.PublisherId);
            }
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data = await this.$store.dispatch('settings/copySite', this.getBody());
                this.loading = false;
                if (data.Status) {
                    this.successSnackbar = true;
                    this.$emit('input', false); // set v-model to false -> close dialog
                } else {
                    this.$root.$emit('snackbar', 'Error: Fehler beim Kopieren', 'error');
                }
            }
        },
        getBody() {
            return {
                site_id: this.selectedSite.SiteId,
                Name: this.name,
                PublisherId: this.selected_publisher.PublisherId
            }
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.init();
            this.$v.$reset();
            this.$emit('input', false);
        }
    },
    watch: {
        selectedSite() {
            if (this.$store.state.settings.activeTab === 'Settings_Sites') this.init();
        }
    }
}
</script>

<style scoped>

</style>